import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function getProductBySku(sku:string): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('productBySku')
    .setMethod('POST')
    .setProps([{sku: sku}])
    .send();
}
